import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SystemUpdateAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"system_update_alt"}/>
}
